import { Icon } from './Icon';
import { IconSvg } from './IconSvg';
Icon.Svg = IconSvg;
export default Icon;
